import { lazy } from 'react'

export const LocatorAppVariant1 = lazy(() => import('./LocatorAppVariant1'))
